import ConvertTime from "./ConvertTime"

const TimeStats = ({ timeStats }) => {
    return (
        <div className='space-y-3 p-3'>
            <div><span className="font-semibold">First Order At : </span> <ConvertTime time={timeStats?.firstorderAt} /> </div>
            <div><span className="font-semibold">First Order Date : </span>{timeStats?.firstorderDate} </div>
            <div><span className="font-semibold">Last Order At : </span> <ConvertTime time={timeStats?.lastoderAt} /> </div>
            <div><span className="font-semibold">Last Order Date : </span>{timeStats?.lastoderDate} </div>
            <div><span className="font-semibold">Last Bill Closed : </span>{timeStats?.lastbillclosedAt} </div>
            <div><span className="font-semibold">Operation Time : </span>{timeStats?.operationTime} </div>
        </div>
    )
}

export default TimeStats